import { render, staticRenderFns } from "./DirectInviteSpeaker.vue?vue&type=template&id=2c4be3f2&"
import script from "./DirectInviteSpeaker.vue?vue&type=script&lang=js&"
export * from "./DirectInviteSpeaker.vue?vue&type=script&lang=js&"
import style0 from "./DirectInviteSpeaker.vue?vue&type=style&index=0&id=2c4be3f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports